import Ticker from "react-ticker";
import React from 'react'
import PropTypes from 'prop-types';
import './style.css';


const TickerComponent = (props) => {
  return (
    
    <> 
<div className="bubble">
        Announcement
     </div>
    <Ticker>
      {() => (
        <>
        
          <div className="tick-card">
          {
            props.data.title.split(';').map(item => (
            <h6 className="tick-heading" key={item}>{item}
              {!item.length > 1 ? <span className="tick-span">|</span> : ''}
            </h6>
            ))
          }
          
          </div>
          
        </>
        
        
      )}
    </Ticker>
    {/* <div>
    <div className="talkbubble "></div> 
    <div className="talkbubble-after"></div>
    <span className="announcement">Announcements</span>
    </div> */}
    
    

    
    </>
  )
}

export default TickerComponent
TickerComponent.propTypes = {
  data : PropTypes.object
}

